export default __webpack_public_path__ + "static/media/step1landing.3a30810e.jpg";